export default "__VITE_ASSET__pPlhgsxM__"